import React, { useEffect, useState } from 'react';
import { Checkbox } from 'antd';
import { CustomButton, CustomParagraph } from '@/components';
import { ActionItem, AddActionDrawerProps } from '../type';

import { getActionIcon } from '../utils/getActionIcon';

const AddActionDrawer: React.FC<AddActionDrawerProps> = ({
  actionsList = [],
  tpSelected,
  setTpSelected,
  drawerState,
  setDrawerState,
}) => {
  // Local temp state so changes are NOT saved until user clicks Save
  const [localSelected, setLocalSelected] = useState<ActionItem[]>([]);
  useEffect(() => {
    setLocalSelected(tpSelected);
  }, [tpSelected, drawerState]);

  // Toggle action selection
  const toggle = (actionType: string) => {
    setLocalSelected((prev) => {
      const exists = prev.some((x) => x.action_type === actionType);
      if (exists) {
        return prev.filter((x) => x.action_type !== actionType);
      } else {
        const fullObj = actionsList.find((x) => x.action_type === actionType);
        return fullObj ? [...prev, fullObj] : prev;
      }
    });
  };

  // Save selected actions
  const handleSave = () => {
    setTpSelected(localSelected);
    setDrawerState('detail');
  };

  return (
    <>
      <div className='aad-header'>
        <CustomParagraph
          text='Add action'
          fontSize='20px'
          lineHeight='28px'
          fontWeight={700}
          color='var(--text-primary)'
          marginBottom={0}
        />
      </div>

      <div className='aad-list'>
        {actionsList.map((item) => {
          // Fix: compare action_type, not whole object
          const isChecked = localSelected.some(
            (x) => x.action_type === item.action_type
          );
          const actionType = item.action_type;
          if (!actionType) return null;
          const Icon = getActionIcon(actionType);

          return (
            <div
              key={actionType}
              className='aad-item'
              onClick={() => toggle(actionType)}
            >
              <Checkbox checked={isChecked} />

              <div className='icon'>
                {Icon && <Icon width={16} height={16} color='currentColor' />}
              </div>

              <div className='details'>
                <div className='title'>{item.title}</div>
                <div className='desc'>{item.description}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div
        // eslint-disable-next-line react/forbid-dom-props -- layout styles predate the strict rule; to move into CSS
        style={{
          background: 'var(--surface-container)',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          padding: '0 24px 24px',
        }}
      >
        <CustomButton
          text='Save'
          bgColor='#000'
          color='#fff'
          fontSize='16px'
          fontWeight='600'
          height='48px'
          width='100%'
          onClick={handleSave}
        />

        <CustomButton
          text='Cancel'
          bgColor='transparent'
          color='var(--text-primary)'
          fontSize='16px'
          fontWeight='600'
          height='auto'
          width='100%'
          padding='11.5px 0px 12px'
          border='none'
          onClick={() => {
            setDrawerState('detail');
            setLocalSelected(tpSelected);
          }}
        />
      </div>
    </>
  );
};

export default AddActionDrawer;
